export default __webpack_public_path__ + "static/media/36I-102816_-16011_0.32fb8018.jpg";